import {showErrorNotification, showSuccessNotification} from "../../global/notifications";

let isLoaded = false;
let isCleared = false;
let _company, _month, _year, _salesperson, _selectedProject;

const previousFields = {
  entryId: {
    type: 'number',
        editable: false,
        nullable: false
  },
  salespersonId: {
    type:'number',
        editable: false
  },
  commissionDate: {
    type: 'date',
        editable: false
  },
  project: {
    type: 'string',
        editable: false
  },
  projectDescription: {
    type: 'string',
        editable: false
  },
  projectStatus: {
    type: 'string',
        editable: false
  },
  openDate: {
    type: 'date',
        editable: false
  },
  closeDate: {
    type: 'date',
        editable: false
  },
  contractBookedAmount: {
    type: 'number',
        editable: false
  },
  contractActualAmount: {
    type: 'number',
        editable: false
  },
  contractChangeAmount: {
    type: 'number',
        editable: false
  },
  costEstimatedAmount: {
    type: 'number',
        editable: false
  },
  costActualAmount: {
    type: 'number',
        editable: false
  },
  costChangeAmount: {
    type: 'number',
        editable: false
  },
  gpOriginalPercent: {
    type: 'number',
        editable: false
  },
  gpOriginalAmount: {
    type: 'number',
        editable: false
  },
  gpFinalPercent: {
    type: 'number',
        editable: false
  },
  gpFinalAmount: {
    type: 'number',
    editable: false
  },
  adjustmentAmount: {
    type: 'number',
    editable: false
  },
  comment: {
    type: 'string',
    editable: false
  }
};

export default function (company, month, year, salesperson) {

  _company = company;
  _month = month;
  _year = year;
  _salesperson = salesperson;
  
  loadAdjustPrevious();
}

function initComponents() {
  const $projectDetails = $('form.projectDetails');
  const $projectDatasource = new kendo.data.DataSource({
    autoSync: false,
    schema: {
      model: {
        id: 'entryId',
        fields: previousFields
      }
    },
    transport: {
      read: {
        dataType: 'json',
        type: 'GET',
        url: '/Finance/GetProjectCommission'
      },
      update: {
        dataType: 'json',
        type: 'PUT',
        url: '/Finance/SaveAdjustment'
      },
      parameterMap(data, type) {
        if(type === 'read') {
          data.salesperson = _salesperson;
          data.project = _selectedProject;
        }
        if(type === 'update') {
          // adjustment amount, comment, GSM PIN
          const formData = {};
          const fields = $projectDetails.serializeArray();
          formData.entryId = $('#entryId').text();
          formData.projectType = $('#projectStatus').text();
          formData.month = _month;
          formData.year = _year;
          $.each(fields, (k,v) => {
            formData[v.name] = v.value;
          });
          data = formData;
        }
        return data;
      }
    },
    requestEnd(e) {
      if(e.type === 'read' && _selectedProject) { // bind response data to form if valid project
        const formData = e.response[0];
        $.each(formData, (k,v) => {
          const valueType = $projectDatasource.options.schema.model.fields[k].type;
          let value;
          switch(valueType) {
            case 'date':
              value = kendo.toString(new Date(v), 'M/d/yyyy');
              break;
            case 'number':
              value = v;
              if(k.includes('Percent')) {
                value = kendo.toString(v, 'p2');
              }
              if(k.includes('Amount')) {
                value = kendo.toString(v, 'c2');
              }
              break;
            default:
              value = v;
          }
          $projectDetails.find(`#${k}`).text(value);
        });
      }
      if(e.type === 'update') {
        if((e.response.length && e.response[0].success === false) // commission was not adjusted
            || (e.response.success !== undefined && e.response.success === false)) {
          showErrorNotification(e.response[0].reason ?? e.response.reason);
          e.preventDefault(true);
        } else { // load fields
          showSuccessNotification('Commission adjustment made!');
          $projectDetails.hide();
          $projectDetails.trigger('reset');
          $searchText.value('');
          $('.grid.prior-adjustments').data('kendoGrid').dataSource.read();
        }
      }
    }
  });
  const $loadButton = $('.typeahead-button.search-project').kendoButton({
    enable: false,
    icon: 'search',
    click(e) {
      $projectDatasource.read();
      if(_selectedProject) {
        $projectDetails.show();
      } else {
        $projectDetails.hide();
      }
    }
  }).data('kendoButton');
  const $saveButton = $('.save-adjustment').kendoButton({
    click(e) {
      if(_selectedProject) {
        const dataItem = $projectDatasource.get($('#entryId').text());
        dataItem.dirty = true;
        $projectDatasource.sync();
      }
    }
  }).data('kendoButton');
  const $searchText = $('.typeahead.search-project').kendoAutoComplete({
    dataSource: {
      autoSync: true,
      schema: {
        id: 'projectId',
        fields: {
          projectName: {
            type: 'string'
          },
          projectId: {
            type: 'string'
          }
        }
      },
      transport: {
        read: {
          dataType: 'json',
          type: 'GET',
          url: '/Finance/AdjustableCommissionProjects'
        },
        parameterMap(data, type) {
          if(type === 'read') {
            data.company = _company;
            data.salesperson = _salesperson;
          }
          return data;
        }
      }
    },
    dataTextField: 'projectName',
    dataValueField: 'projectId',
    filter: 'contains',
    placeholder: 'Find a project to adjust...', 
    noDataTemplate: 'No matching projects found.',
    change(e) {
      _selectedProject = $searchText.dataSource.data().find(i => i.projectName === $searchText._oldText).projectId;
    },
    select(e) {
      $loadButton.enable(true);
    }
  }).data('kendoAutoComplete');
  const $amountEntry = $('#adjustmentAmount').kendoNumericTextBox({
    format: 'c2',
    step: 1.0,
    restrictDecimals: true,
    decimals: 2,
    round: false
  });
  const $clearSearch = $('.k-clear-value.k-i-close');
  $clearSearch.on('click', (e) => {
    $loadButton.enable(false);
  });
}

function loadPrevious() {
  if(isLoaded) return;
  const $priorAdjs = $('.grid.prior-adjustments').kendoGrid({
    dataSource: {
      schema: {
        model: {
          fields: previousFields
        }
      },
      transport: {
        read: {
          dataType: 'json',
          type: 'GET',
          url: '/Finance/GetPriorAdjustments'
        },
        parameterMap(data, type) {
          if (type === 'read') {
            data.company = _company;
            data.month = _month;
            data.year = _year;
            data.salesperson = _salesperson;
          }
          return data;
        }
      },
    },
    columns: [
      {
        title: 'Project',
        field: 'projectDescription',
        headerAttributes: {style: 'white-space: normal'},
        width: '200px',
        template(dataItem) {
          return `${dataItem.project} - ${dataItem.projectDescription}`;
        }
      },
      {
        title: 'Opened',
        field: 'openDate',
        headerAttributes: {style: 'white-space: normal'},
        width: '90px',
        template(dataItem) {
          return `${kendo.toString(dataItem.openDate, 'd')}`;
        }
      },
      {
        title: 'Closed',
        field: 'monthStart',
        headerAttributes: {style: 'white-space: normal'},
        width: '90px',
        template(dataItem) {
          return `${kendo.toString(dataItem.closeDate, 'd')}`;
        }
      },
      {
        title: 'Contract Amount',
        field: 'contractActualAmount',
        headerAttributes: {style: 'white-space: normal'},
        width: '100px',
        template(dataItem) {
           return `
              <div>
                <div style="width: 100%;">${kendo.toString(dataItem.contractBookedAmount, 'c2')}</div>
                <div style="width: 100%;">${kendo.toString(dataItem.contractActualAmount, 'c2')}</div>
              </div>`;
        }
      },
      {
        title: 'Cost Amount',
        field: 'costActualAmount',
        headerAttributes: {style: 'white-space: normal'},
        width: '100px',
        template(dataItem) {
          return `
              <div>
                <div style="width: 100%;">${kendo.toString(dataItem.costEstimatedAmount, 'c2')}</div>
                <div style="width: 100%;">${kendo.toString(dataItem.costActualAmount, 'c2')}</div>
              </div>`;
        }
      },
      {
        title: 'GP Amount',
        field: 'gpFinalAmount',
        headerAttributes: {style: 'white-space: normal'},
        width: '100px',
        template(dataItem) {
          return `
              <div>
                <div style="width: 100%;">${kendo.toString(dataItem.gpOriginalAmount, 'c2')}</div>
                <div style="width: 100%;">${kendo.toString(dataItem.gpFinalAmount, 'c2')}</div>
              </div>`;
        }
      },
      {
        title: 'Adjustment Amount',
        field: 'adjustmentAmount',
        headerAttributes: {style: 'white-space: normal'},
        width: '100px',
        template(dataItem) {
          return `${kendo.toString(dataItem.adjustmentAmount, 'c2')}`;
        }
      },
      {
        title: 'Comment',
        field: 'adjustmentAmount',
        headerAttributes: {style: 'white-space: normal'},
        width: '200px',
        template(dataItem) {
          return `${dataItem.comment}`;
        }
      }],
    editable: false,
    resizable: false,
    scrollable: true,
    sortable: true,
    filterable: {
      operators: {
        string: {
          contains: 'Contains',
          startswith: 'Starts with'
        }
      }
    },
    pageable: {
      alwaysVisible: true,
      pageSize: 10,
      pageSizes: [5,10,25,50,'all'],
      buttonCount: 20
    },
    noRecords: {
      template: "No adjustments have been made."
    }
  }).data('kendoGrid');
}

function loadAdjustPrevious() {
  $('.js-ssr-commissions-adjust-previous').load('/Finance/AdjustPrevious',
    callback => {
      initComponents();
      loadPrevious();
      isLoaded = true;
    });
}